var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWasherColor = function SvgWasherColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34851 9.75964C3.27315 9.6343 3.08476 9.64325 3.01883 9.75964C2.63262 10.4132 1.67182 12.0248 1.25736 12.5889C0.880572 13.0902 0.720439 13.7438 0.918251 14.4422C1.12548 15.1942 1.77544 15.812 2.56668 16.009C4.13034 16.394 5.53386 15.2748 5.53386 13.8513C5.53386 13.4573 5.42083 13.0902 5.23243 12.7679C4.82739 12.0964 3.77239 10.4132 3.35793 9.75069L3.34851 9.75964Z",
    fill: "#33DAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9813 9.75964C16.906 9.6343 16.7176 9.64325 16.6516 9.75964C16.2654 10.4132 15.3046 12.0248 14.8902 12.5889C14.5134 13.0902 14.3533 13.7438 14.5511 14.4422C14.7583 15.1942 15.4082 15.812 16.1995 16.009C17.7632 16.394 19.1667 15.2748 19.1667 13.8513C19.1667 13.4573 19.0536 13.0902 18.8652 12.7679C18.4602 12.0964 17.4052 10.4132 16.9907 9.75069L16.9813 9.75964Z",
    fill: "#33DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.193 4.27076C10.1087 4.13197 9.90277 4.13197 9.81852 4.27076C9.29424 5.20524 7.75886 7.8884 7.11288 8.79513C6.59797 9.51681 6.35455 10.4235 6.53243 11.4043C6.78521 12.7921 7.92738 13.9394 9.33169 14.1892C11.5692 14.5963 13.5259 12.9031 13.5259 10.7659C13.5259 10.1552 13.3574 9.58157 13.0765 9.08195C12.4493 7.99018 10.7641 5.21449 10.193 4.27076Z",
    fill: "#007AFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWasherColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "washer-color.c4e50788d6f9bcc7a5905544163309b3.svg";